/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ShareInvitationDto } from '../models/share-invitation-dto';
import { ShareLinkDto } from '../models/share-link-dto';
import { sharingLinksPost$Json } from '../fn/sharing/sharing-links-post-json';
import { SharingLinksPost$Json$Params } from '../fn/sharing/sharing-links-post-json';
import { sharingLinksPost$Plain } from '../fn/sharing/sharing-links-post-plain';
import { SharingLinksPost$Plain$Params } from '../fn/sharing/sharing-links-post-plain';
import { sharingLinksResourceTypeResourceIdGet$Json } from '../fn/sharing/sharing-links-resource-type-resource-id-get-json';
import { SharingLinksResourceTypeResourceIdGet$Json$Params } from '../fn/sharing/sharing-links-resource-type-resource-id-get-json';
import { sharingLinksResourceTypeResourceIdGet$Plain } from '../fn/sharing/sharing-links-resource-type-resource-id-get-plain';
import { SharingLinksResourceTypeResourceIdGet$Plain$Params } from '../fn/sharing/sharing-links-resource-type-resource-id-get-plain';
import { sharingLinksShareLinkIdGet$Json } from '../fn/sharing/sharing-links-share-link-id-get-json';
import { SharingLinksShareLinkIdGet$Json$Params } from '../fn/sharing/sharing-links-share-link-id-get-json';
import { sharingLinksShareLinkIdGet$Plain } from '../fn/sharing/sharing-links-share-link-id-get-plain';
import { SharingLinksShareLinkIdGet$Plain$Params } from '../fn/sharing/sharing-links-share-link-id-get-plain';
import { sharingLinksShareLinkIdInvitePost$Json } from '../fn/sharing/sharing-links-share-link-id-invite-post-json';
import { SharingLinksShareLinkIdInvitePost$Json$Params } from '../fn/sharing/sharing-links-share-link-id-invite-post-json';
import { sharingLinksShareLinkIdInvitePost$Plain } from '../fn/sharing/sharing-links-share-link-id-invite-post-plain';
import { SharingLinksShareLinkIdInvitePost$Plain$Params } from '../fn/sharing/sharing-links-share-link-id-invite-post-plain';
import { sharingLinksShareLinkIdRevokePost } from '../fn/sharing/sharing-links-share-link-id-revoke-post';
import { SharingLinksShareLinkIdRevokePost$Params } from '../fn/sharing/sharing-links-share-link-id-revoke-post';

@Injectable({ providedIn: 'root' })
export class SharingApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `sharingLinksPost()` */
  static readonly SharingLinksPostPath = '/sharing/links';

  /**
   * Create share link.
   *
   * Creates a share link for a dashboard or query in the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sharingLinksPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sharingLinksPost$Plain$Response(params?: SharingLinksPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareLinkDto>> {
    const obs = sharingLinksPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create share link.
   *
   * Creates a share link for a dashboard or query in the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sharingLinksPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sharingLinksPost$Plain(params?: SharingLinksPost$Plain$Params, context?: HttpContext): Observable<ShareLinkDto> {
    const resp = this.sharingLinksPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShareLinkDto>): ShareLinkDto => r.body)
    );
  }

  /**
   * Create share link.
   *
   * Creates a share link for a dashboard or query in the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sharingLinksPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sharingLinksPost$Json$Response(params?: SharingLinksPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareLinkDto>> {
    const obs = sharingLinksPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create share link.
   *
   * Creates a share link for a dashboard or query in the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sharingLinksPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sharingLinksPost$Json(params?: SharingLinksPost$Json$Params, context?: HttpContext): Observable<ShareLinkDto> {
    const resp = this.sharingLinksPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShareLinkDto>): ShareLinkDto => r.body)
    );
  }

  /** Path part for operation `sharingLinksShareLinkIdGet()` */
  static readonly SharingLinksShareLinkIdGetPath = '/sharing/links/{shareLinkId}';

  /**
   * Get share link.
   *
   * Returns details and status for a share link.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sharingLinksShareLinkIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  sharingLinksShareLinkIdGet$Plain$Response(params: SharingLinksShareLinkIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareLinkDto>> {
    const obs = sharingLinksShareLinkIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get share link.
   *
   * Returns details and status for a share link.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sharingLinksShareLinkIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sharingLinksShareLinkIdGet$Plain(params: SharingLinksShareLinkIdGet$Plain$Params, context?: HttpContext): Observable<ShareLinkDto> {
    const resp = this.sharingLinksShareLinkIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShareLinkDto>): ShareLinkDto => r.body)
    );
  }

  /**
   * Get share link.
   *
   * Returns details and status for a share link.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sharingLinksShareLinkIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  sharingLinksShareLinkIdGet$Json$Response(params: SharingLinksShareLinkIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareLinkDto>> {
    const obs = sharingLinksShareLinkIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get share link.
   *
   * Returns details and status for a share link.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sharingLinksShareLinkIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sharingLinksShareLinkIdGet$Json(params: SharingLinksShareLinkIdGet$Json$Params, context?: HttpContext): Observable<ShareLinkDto> {
    const resp = this.sharingLinksShareLinkIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShareLinkDto>): ShareLinkDto => r.body)
    );
  }

  /** Path part for operation `sharingLinksResourceTypeResourceIdGet()` */
  static readonly SharingLinksResourceTypeResourceIdGetPath = '/sharing/links/{resourceType}/{resourceId}';

  /**
   * List share links for resource.
   *
   * Lists all share links created for a dashboard or query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sharingLinksResourceTypeResourceIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  sharingLinksResourceTypeResourceIdGet$Plain$Response(params: SharingLinksResourceTypeResourceIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShareLinkDto>>> {
    const obs = sharingLinksResourceTypeResourceIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List share links for resource.
   *
   * Lists all share links created for a dashboard or query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sharingLinksResourceTypeResourceIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sharingLinksResourceTypeResourceIdGet$Plain(params: SharingLinksResourceTypeResourceIdGet$Plain$Params, context?: HttpContext): Observable<Array<ShareLinkDto>> {
    const resp = this.sharingLinksResourceTypeResourceIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ShareLinkDto>>): Array<ShareLinkDto> => r.body)
    );
  }

  /**
   * List share links for resource.
   *
   * Lists all share links created for a dashboard or query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sharingLinksResourceTypeResourceIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  sharingLinksResourceTypeResourceIdGet$Json$Response(params: SharingLinksResourceTypeResourceIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShareLinkDto>>> {
    const obs = sharingLinksResourceTypeResourceIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List share links for resource.
   *
   * Lists all share links created for a dashboard or query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sharingLinksResourceTypeResourceIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sharingLinksResourceTypeResourceIdGet$Json(params: SharingLinksResourceTypeResourceIdGet$Json$Params, context?: HttpContext): Observable<Array<ShareLinkDto>> {
    const resp = this.sharingLinksResourceTypeResourceIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ShareLinkDto>>): Array<ShareLinkDto> => r.body)
    );
  }

  /** Path part for operation `sharingLinksShareLinkIdRevokePost()` */
  static readonly SharingLinksShareLinkIdRevokePostPath = '/sharing/links/{shareLinkId}/revoke';

  /**
   * Revoke share link.
   *
   * Marks a share link as revoked.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sharingLinksShareLinkIdRevokePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  sharingLinksShareLinkIdRevokePost$Response(params: SharingLinksShareLinkIdRevokePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = sharingLinksShareLinkIdRevokePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Revoke share link.
   *
   * Marks a share link as revoked.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sharingLinksShareLinkIdRevokePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sharingLinksShareLinkIdRevokePost(params: SharingLinksShareLinkIdRevokePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.sharingLinksShareLinkIdRevokePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sharingLinksShareLinkIdInvitePost()` */
  static readonly SharingLinksShareLinkIdInvitePostPath = '/sharing/links/{shareLinkId}/invite';

  /**
   * Invite user by email.
   *
   * Sends an email invitation with the share link to a recipient.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sharingLinksShareLinkIdInvitePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sharingLinksShareLinkIdInvitePost$Plain$Response(params: SharingLinksShareLinkIdInvitePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareInvitationDto>> {
    const obs = sharingLinksShareLinkIdInvitePost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Invite user by email.
   *
   * Sends an email invitation with the share link to a recipient.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sharingLinksShareLinkIdInvitePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sharingLinksShareLinkIdInvitePost$Plain(params: SharingLinksShareLinkIdInvitePost$Plain$Params, context?: HttpContext): Observable<ShareInvitationDto> {
    const resp = this.sharingLinksShareLinkIdInvitePost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShareInvitationDto>): ShareInvitationDto => r.body)
    );
  }

  /**
   * Invite user by email.
   *
   * Sends an email invitation with the share link to a recipient.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sharingLinksShareLinkIdInvitePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sharingLinksShareLinkIdInvitePost$Json$Response(params: SharingLinksShareLinkIdInvitePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareInvitationDto>> {
    const obs = sharingLinksShareLinkIdInvitePost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Invite user by email.
   *
   * Sends an email invitation with the share link to a recipient.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sharingLinksShareLinkIdInvitePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sharingLinksShareLinkIdInvitePost$Json(params: SharingLinksShareLinkIdInvitePost$Json$Params, context?: HttpContext): Observable<ShareInvitationDto> {
    const resp = this.sharingLinksShareLinkIdInvitePost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShareInvitationDto>): ShareInvitationDto => r.body)
    );
  }

}
